module.exports = __webpack_public_path__ + "static/img/bg-banner-case-detail-expressway.0e01fa14.png";